import { render, staticRenderFns } from "./ModalUploadLaudosEmLote.vue?vue&type=template&id=39531b10&lang=pug"
import script from "./ModalUploadLaudosEmLote.vue?vue&type=script&lang=js"
export * from "./ModalUploadLaudosEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadLaudosEmLote.vue?vue&type=style&index=0&id=39531b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports